<script lang="ts" setup>
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAccountStore } from '@/stores';
import { getUserType } from '@/utils/users';

import AppModal from '../AppModal.vue';

const router = useRouter();
const accountStore = useAccountStore();
const { accounts, currentId, isSelectorOpen } = storeToRefs(accountStore);
const { setCurrentAccount } = accountStore;

// const selectedId = ref(currentId.value);
const selectedId = computed({
  get: () => currentId.value,
  set: (value: number) => {
    setCurrentAccount(value);
  },
})

watch(selectedId, (newId) => {
  if (newId) {
    router.push({ name: 'home' });
  }
});

</script>

<template>
  <AppModal title="Select account" v-model="isSelectorOpen">

    <p class="text-gray-500 mb-4">
      Select the account you want to use. Changing accounts will redirect you to the home page.
    </p>

    <form>
      <fieldset aria-label="Select account" class="-space-y-px rounded-md bg-white">
        <label v-for="account in accounts" :key="account.accountId" :aria-label="account.accountName" class="group flex cursor-pointer border border-gray-200 p-4 first:rounded-tl-md first:rounded-tr-md last:rounded-bl-md last:rounded-br-md focus:outline-none has-[:checked]:relative has-[:checked]:border-indigo-200 has-[:checked]:bg-indigo-50">
          <input name="current-account-id" v-model="selectedId" :value="account.accountId" type="radio" class="relative mt-0.5 size-4 shrink-0 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden" />
          <span class="ml-3 flex flex-col">
            <span class="block text-sm font-medium text-gray-900 group-has-[:checked]:text-indigo-900">
              {{ account.accountName }}</span>
            <span class="block text-sm text-gray-500 group-has-[:checked]:text-indigo-700">
              {{ getUserType(account.userType) }}
            </span>
          </span>
        </label>
      </fieldset>
    </form>
  </AppModal>
</template>
